import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SpinnerIcon } from '../../../../../../../../components/Commons/SpinnerIcon/styles';
import { loadBilledOrderTracking } from '../../../../../../../../store/ducks/long-steel-orders/actions';
import { IBilledOrderData } from '../../../../../../../../store/ducks/long-steel-orders/types';
import moment from 'moment';
import {
  TrackingContainer,
  TrackingTimeline,
  DeliveredIcon
} from '../../../../../../../../components/Commons/Tables/TrackingOrder/styles';

interface ITrackingBilledOrderProps {
  billedOrderItem: IBilledOrderData;
}

interface ITransportLogData {
  date: string;
  label: string;
}

interface IBilledTransportLogData {
  createdDate: string;
  receiver: {
    name: string;
    type: string;
  };
  transportType: 'entrada' | 'saida';
}
interface ITrackingBilledLog {
  isDelivered: boolean;
  statusLabel: string;
  deliveryDate: string;
  billedDate: string;
  transportLog: ITransportLogData[];
}

interface ITransportData {
  carrierName: string;
  carrierTaxNumber: string;
  loadingDate: string;
  loadingEndDate: string;
  loadingStatus: string;
  modalType: string;
}

const TrackingBilledOrder: React.FC<ITrackingBilledOrderProps> = ({
  billedOrderItem
}) => {
  const dispatch = useDispatch();

  const [trackingBilledLog, setTrackingBilledLog] = useState<
    ITrackingBilledLog | undefined
  >();

  const searchBilledItemTracking = () => {
    dispatch(loadBilledOrderTracking(billedOrderItem));
  };

  const initTrackingBilledLog = () => {
    if (billedOrderItem.trackingState.tracking) {
      const trackingBilled = billedOrderItem.trackingState.tracking;
      const isDelivered =
        trackingBilled.transportStatus.toLowerCase() === 'entregue';

      const newTrackingBilledLog: ITrackingBilledLog = {
        isDelivered,
        statusLabel: isDelivered ? 'Entregue' : 'Entrega prevista',
        deliveryDate: isDelivered
          ? trackingBilled.deliveryDate
            ? moment(new Date(trackingBilled.deliveryDate)).format('DD/MM/YYYY')
            : ' - '
          : trackingBilled.estimateDate
          ? moment(new Date(trackingBilled.estimateDate)).format('DD/MM/YYYY')
          : ' - ',
        billedDate: moment(trackingBilled.billedDate, 'YYYY-MM-DD').format(
          'DD/MM/YYYY'
        ),
        transportLog: []
      };

      trackingBilled.transportData.forEach((data: ITransportData) => {
        let transportLabel = '';
        if (data.modalType.toLowerCase() === 'ferroviário') {
          transportLabel = 'Transporte ferroviário';
        } else if (data.modalType.toLowerCase() === 'rodoviário') {
          transportLabel = 'Transporte rodoviário';
        }

        newTrackingBilledLog.transportLog.push({
          date: data.loadingEndDate
            ? moment(new Date(data.loadingEndDate)).format('DD/MM/YYYY')
            : moment(new Date(data.loadingDate)).format('DD/MM/YYYY'),
          label: transportLabel
        });
      });

      trackingBilled.transportLog.forEach((item: IBilledTransportLogData) => {
        if (
          item.transportType.toLowerCase() === 'saida' &&
          item.receiver &&
          item.receiver.type.toLowerCase() === 'terminal'
        ) {
          newTrackingBilledLog.transportLog.push({
            date: moment(new Date(item.createdDate)).format('DD/MM/YYYY'),
            label: 'Em estoque terminal'
          });
        }
      });

      setTrackingBilledLog(newTrackingBilledLog);
    }
  };

  useEffect(() => {
    if (
      !billedOrderItem.trackingState ||
      (!billedOrderItem.trackingState.tracking &&
        !billedOrderItem.trackingState.loading &&
        !billedOrderItem.trackingState.error)
    ) {
      searchBilledItemTracking();
    } else if (!trackingBilledLog && billedOrderItem.trackingState) {
      initTrackingBilledLog();
    }
  });

  return (
    <TrackingContainer>
      {billedOrderItem.trackingState &&
        !billedOrderItem.trackingState.error &&
        billedOrderItem.trackingState.tracking &&
        trackingBilledLog && (
          <>
            <div
              className={`status ${
                trackingBilledLog.isDelivered ? 'delivered' : ''
              }`}
            >
              <h4>
                <strong>{trackingBilledLog.statusLabel}</strong>
              </h4>
              {trackingBilledLog.isDelivered ? (
                <DeliveredIcon />
              ) : (
                <span>{trackingBilledLog.deliveryDate}</span>
              )}
            </div>

            <TrackingTimeline>
              <div>
                <span>{trackingBilledLog.billedDate}</span>
                <div className="dot paint-row"></div>
                <h4>Emissão da nota</h4>
              </div>

              <>
                {trackingBilledLog.transportLog.map((log, idx) => (
                  <div key={idx}>
                    <span>{log.date}</span>
                    <div className="dot paint-row"></div>
                    <h4>{log.label}</h4>
                  </div>
                ))}
              </>

              <div>
                <span>
                  {trackingBilledLog.isDelivered
                    ? trackingBilledLog.deliveryDate
                    : ''}
                </span>
                <div
                  className={`dot ${
                    trackingBilledLog.isDelivered ? 'paint-row' : 'disabled'
                  }`}
                ></div>
                <h4>Entregue</h4>
              </div>
            </TrackingTimeline>
          </>
        )}

      {billedOrderItem.trackingState &&
        billedOrderItem.trackingState.loading && <SpinnerIcon />}

      {billedOrderItem.trackingState && billedOrderItem.trackingState.error && (
        <div className="tracking-error">
          <span>Informações de rastreio da NF indisponíveis.</span>
        </div>
      )}
    </TrackingContainer>
  );
};

export default TrackingBilledOrder;
